import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import CaseTemplateEditModal from './CaseTemplateEditModal';
import { strings } from '../../assets/strings/all';
function CaseTemplateEditButton(props) {
  const [show, setShow] = useState(false);
  const { common } = strings;
  const toggleShow = () => {
    setShow(!show);
  };

  return (
    <>
      <Button
        variant="link"
        onClick={() => {
          toggleShow();
        }}
      >
        {common.edit}
      </Button>
      {show ? (
        <CaseTemplateEditModal
          show={show}
          {...props}
          onClose={() => {
            toggleShow();
          }}
        />
      ) : (
        <></>
      )}
    </>
  );
}

export default CaseTemplateEditButton;
